import React from 'react';
import {
  Box,
  VStack,
  Heading,
  Text,
  Image,
  useColorModeValue,
} from '@chakra-ui/react';
import { TeamMember } from '../types';
import { resolveAsset, getInitials } from '../../../shared/utils/assets';

interface TeamMemberPresentationProps {
  member: TeamMember;
}

const TeamMemberPresentation: React.FC<TeamMemberPresentationProps> = ({
  member
}) => {
  const cardBg = useColorModeValue('white', 'gray.700');

  return (
    <Box 
      bg={cardBg}
      p={6}
      borderRadius="lg"
      boxShadow="md"
      textAlign="center"
    >
      <VStack spacing={4}>
        <Box 
          width="150px" 
          height="150px" 
          borderRadius="full" 
          overflow="hidden"
          bg="gray.200"
        >
          <Image 
            src={member.image.startsWith('/src/') ? member.image.substring(1) : resolveAsset(member.image, "image")} 
            alt={member.name}
            width="100%"
            height="100%"
            objectFit="cover"
            fallback={
              <Box 
                width="100%" 
                height="100%" 
                display="flex" 
                alignItems="center" 
                justifyContent="center"
                bg="gray.200"
                color="gray.500"
              >
                {getInitials(member.name)}
              </Box>
            }
          />
        </Box>
        <Heading as="h4" size="md">
          {member.name}
        </Heading>
        <Text color="brand.primary.base" fontWeight="medium">
          {member.role}
        </Text>
        <Text color="gray.600" fontSize="sm">
          {member.bio}
        </Text>
      </VStack>
    </Box>
  );
};

export default TeamMemberPresentation;